import {PinProtect} from '~/features/Auth/PinProtect';
import {WeeklyChallengeListDetails} from '~/features/Challenges/WeeklyChallengeList';

export const WeeklyChallengeListScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <WeeklyChallengeListDetails />
      </PinProtect>
    </div>
  );
};
